import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const updateWorkRequestStatus = async (ID, status, declinedReason) => {
  try {
    let params = {
      status,
      declinedReason,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "work-requests/" + ID,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const createNewWorkRequest = async (
  title,
  description,
  priority,
  location,
  assets,
  people,
  teams,
  logo,
  attachments,
  organisation = "",
  submittedBy = null
) => {
  try {
    let params = {
      title,
      description,
      priority,
      location,
      assets,
      people,
      teams,
      logo,
      attachments,
      organisation,
      submittedBy,
    };

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "work-requests",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const updateWorkRequest = async (
  id,
  title,
  description,
  priority,
  location,
  assets,
  people,
  teams,
  logo,
  attachments,
  organisation = "",
  submittedBy = null
) => {
  try {
    let params = {
      title,
      description,
      priority,
      location,
      assets,
      people,
      teams,
      logo,
      attachments,
      organisation,
      submittedBy,
    };

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "work-requests/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const getAllWorkRequest = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 99999,
  role,
  currentUserId,
  userId = "",
  people = [],
  status = [],
  priority = [],
  location = [],
  assets = [],
  submissionDate = [],
  sort = []
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    assets: {
      id: {
        $in: assets,
      },
    },
    people: {},
  };

  if (["requester", "user", "view_only"].includes(role)) {
    if (["requester", "user", "view_only"].includes(role)) {
      assetFilters.$or = [
        {
          submittedBy: {
            id: {
              $in: userId,
            },
          },
        },
        {
          people: {
            id: {
              $in: userId,
            },
          },
        },
        {
          people: {
            supervisor: {
              id: {
                $in: userId,
              },
            },
          },
        },
      ];

      if (location?.length > 0) {
        assetFilters.location = {
          id: {
            $in: location,
          },
        };
      }
    }
  } else {
    if (people.length > 0) {
      assetFilters.submittedBy = {
        id: {
          $in: people,
        },
      };
    }
    if (location.length > 0) {
      assetFilters.location = {
        id: {
          $in: location,
        },
      };
    }
  }

  if (submissionDate.length === 1) {
    assetFilters.createdAt = {
      $gte: submissionDate[0],
    };
  } else if (submissionDate.length === 2) {
    assetFilters.createdAt = {
      $gte: submissionDate[0],
      $lte: submissionDate[1],
    };
  }
  if (status) {
    assetFilters.status = {
      $eq: status[0],
    };
  }

  if (priority) {
    assetFilters.priority = {
      $eq: priority[0],
    };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "teams",
      "submittedBy",
      "submittedBy.profileImage",
      "people",
      "people.role",
      "people.userProfile",
      "people.supervisor",
      "people.profileImage",
      "location",
      "assets",
      "reason",
      "logs",
      "attachments",
      "createdByUser",
      "updatedByUser",
      "workOrder",
      "logo",
      "log",
      "log.user",
      "log.user.userProfile",
      "log.user.profileImage",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });

  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `work-requests?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};

export const deleteWorkRequest = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };
    const response = await uninterceptedAxiosInstance.post(
      backend_url + "work-requests/removeWorkRequests",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
